import { render, staticRenderFns } from "./base-typography.vue?vue&type=template&id=78cec505&scoped=true"
import script from "./base-typography.vue?vue&type=script&lang=js"
export * from "./base-typography.vue?vue&type=script&lang=js"
import style0 from "./base-typography.vue?vue&type=style&index=0&id=78cec505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cec505",
  null
  
)

export default component.exports